module.exports = __webpack_public_path__ + "img/img1.d7675b43.png";